import React from 'react';
import { Link } from 'react-router-dom';
import { Award, Clock, Globe, Users, CheckCircle2 } from 'lucide-react';

const Courses = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Courses & <span className="text-cyan-400">Internship</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Transform your future with our comprehensive Robotics and IoT training programs
          </p>
        </div>
      </section>

      {/* Course Banners */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Robotics & IoT Course */}
            <div className="bg-slate-900/50 backdrop-blur-sm border border-cyan-500/20 rounded-2xl overflow-hidden hover:border-cyan-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/20">
              <img 
                src="/robotics-iot-course.png" 
                alt="21 Days Robotics & IoT Workshop"
                className="w-full h-auto"
              />
            </div>

            {/* Python Programming Course */}
            <div className="bg-slate-900/50 backdrop-blur-sm border border-cyan-500/20 rounded-2xl overflow-hidden hover:border-cyan-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/20">
              <img 
                src="/python-course.png" 
                alt="30 Days Python Programming Workshop"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Internship Information */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Robotics & IoT Internship */}
            <div className="bg-gradient-to-br from-cyan-500/10 to-blue-500/10 backdrop-blur-sm border border-cyan-500/30 rounded-2xl p-8">
              <h2 className="text-3xl font-bold text-white mb-6 text-center">
                Robotics & IoT Internship
              </h2>
              <p className="text-gray-300 text-center mb-6 leading-relaxed">
                Join our comprehensive Robotics and IoT Internship program designed to provide hands-on experience 
                in cutting-edge technologies. Available both online and offline. Certificate provided upon completion.
              </p>

              <div className="space-y-4">
                <div className="flex items-start space-x-3 bg-slate-900/50 rounded-lg p-4 border border-cyan-500/20">
                  <div className="w-10 h-10 bg-cyan-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Clock className="text-cyan-400" size={20} />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold">21 Days Program</h3>
                    <p className="text-gray-400 text-sm">IoT, Arduino, ESP32, and real-world projects</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3 bg-slate-900/50 rounded-lg p-4 border border-cyan-500/20">
                  <div className="w-10 h-10 bg-cyan-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Award className="text-cyan-400" size={20} />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold">₹2,100 Only</h3>
                    <p className="text-gray-400 text-sm">Launch offer - Limited seats available</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3 bg-slate-900/50 rounded-lg p-4 border border-cyan-500/20">
                  <div className="w-10 h-10 bg-cyan-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Globe className="text-cyan-400" size={20} />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold">Online & Offline</h3>
                    <p className="text-gray-400 text-sm">Learn from anywhere or attend at our centers</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Python Programming Course */}
            <div className="bg-gradient-to-br from-cyan-500/10 to-blue-500/10 backdrop-blur-sm border border-cyan-500/30 rounded-2xl p-8">
              <h2 className="text-3xl font-bold text-white mb-6 text-center">
                Python Programming Course
              </h2>
              <p className="text-gray-300 text-center mb-6 leading-relaxed">
                Master Python programming from basics to advanced concepts with hands-on projects. Learn to build 
                calculators, solve math problems, image prediction, and many more real-world applications. Certificate provided.
              </p>

              <div className="space-y-4">
                <div className="flex items-start space-x-3 bg-slate-900/50 rounded-lg p-4 border border-cyan-500/20">
                  <div className="w-10 h-10 bg-cyan-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Clock className="text-cyan-400" size={20} />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold">30 Days Program</h3>
                    <p className="text-gray-400 text-sm">Complete Python programming with practical projects</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3 bg-slate-900/50 rounded-lg p-4 border border-cyan-500/20">
                  <div className="w-10 h-10 bg-cyan-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Award className="text-cyan-400" size={20} />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold">₹1,900 Only</h3>
                    <p className="text-gray-400 text-sm">Launch offer - Limited seats available</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3 bg-slate-900/50 rounded-lg p-4 border border-cyan-500/20">
                  <div className="w-10 h-10 bg-cyan-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Globe className="text-cyan-400" size={20} />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold">Online & Offline</h3>
                    <p className="text-gray-400 text-sm">Flexible learning options to suit your schedule</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What You'll Learn */}
      <section className="py-16 bg-slate-900/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center">
            What You'll Learn
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Robotics & IoT Curriculum */}
            <div>
              <h3 className="text-2xl font-bold text-cyan-400 mb-6">Robotics & IoT</h3>
              <div className="grid grid-cols-1 gap-3">
                {[
                  'Arduino Programming',
                  'ESP32 Basics',
                  'IoT Concepts & Implementation',
                  'Sensors & Actuators Integration',
                  'Programming Basics',
                  'Hardware Interfacing',
                  'Real World Applications',
                  'Bluetooth Control Projects',
                  'Traffic Light System',
                  'Home Automation',
                  'Build & Innovate Projects',
                  'Hands-On Practical Experience'
                ].map((item, index) => (
                  <div key={index} className="flex items-center space-x-3 text-gray-300">
                    <CheckCircle2 className="text-cyan-400 flex-shrink-0" size={20} />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Python Programming Curriculum */}
            <div>
              <h3 className="text-2xl font-bold text-cyan-400 mb-6">Python Programming</h3>
              <div className="grid grid-cols-1 gap-3">
                {[
                  'Python Basics',
                  'Data Types & Variables',
                  'Operators & Expressions',
                  'Control Statements',
                  'Functions & Modules',
                  'Data Structures',
                  'File Handling',
                  'Exception Handling',
                  'OOPs Concepts',
                  'Real World Applications',
                  'Calculator Project',
                  'Math Problem Solver',
                  'Image Prediction',
                  'Mini Projects & Code Files'
                ].map((item, index) => (
                  <div key={index} className="flex items-center space-x-3 text-gray-300">
                    <CheckCircle2 className="text-cyan-400 flex-shrink-0" size={20} />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-gradient-to-r from-cyan-500/10 to-blue-500/10 backdrop-blur-sm border border-cyan-500/30 rounded-2xl p-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Ready to Start Your Journey?
            </h2>
            <p className="text-lg text-gray-400 mb-8">
              Limited seats available! Choose Robotics & IoT (21 days) or Python Programming (30 days). Both batches start from the 2nd week of May
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/contact"
                className="inline-block px-8 py-4 bg-cyan-500 text-white rounded-lg font-semibold hover:bg-cyan-600 transform hover:scale-105 transition-all duration-300 shadow-lg shadow-cyan-500/30"
              >
                Register Now
              </Link>
              <a
                href="tel:9762717034"
                className="inline-block px-8 py-4 bg-white/5 backdrop-blur-sm text-white border border-cyan-500/30 rounded-lg font-semibold hover:bg-white/10 transform hover:scale-105 transition-all duration-300"
              >
                Call: 9762717034
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Courses;
